"use client";
import type { CommunityEvent } from "@/types/microCMS/event";

type Props = {
	category: CommunityEvent["category"];
};
/*
定期イベント：青
月次イベント：黄色
ビッグイベント：赤
その他：グレー
* */
export const CategoryTag = (props: Props) => {
	const color = props.category.includes("regular")
		? "bg-[#e0f2fe]"
		: props.category.includes("monthly")
			? "bg-[#bbf7d0]"
			: props.category.includes("spot")
				? "bg-[#ffdead]"
				: "bg-[#ff80aa]";
	return (
		<div
			className={`flex justify-center ${color} rounded-full w-fit px-4 font-bold`}
		>
			<p>
				{props.category.includes("regular")
					? "定期イベント"
					: props.category.includes("monthly")
						? "月次イベント"
						: props.category.includes("spot")
							? "スポットイベント"
							: props.category.includes("monthly")
								? "大型イベント"
								: props.category.includes("big")
									? "大型イベント"
									: ""}
			</p>
		</div>
	);
};
